<template>
    		<!-- Footer -->
		<footer class="footer footer-eight">
			<!-- Footer Top -->
			<div class="footer-top aos aos-init aos-animate" data-aos="fade-up">
				<div class="container">
					<!-- /Footer  Counter Section-->
					<div class="row">
						<div class="col-lg-2 col-md-6 aos" data-aos="fade-up">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Company</h2>
								<ul>
									<li>
										<a href="javascript:void(0)">About Us</a>
									</li>
									<li>
										<a href="javascript:void(0)">Careers</a>
									</li>
									<li>
										<a href="javascript:void(0)">Press</a>
									</li>
									<li>
										<a href="javascript:void(0)">News</a>
									</li>
									<li>
										<a href="javascript:void(0)">Media Kit</a>
									</li>
									<li>
										<a href="javascript:void(0)">Contact</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-2 col-md-6 aos" data-aos="fade-up">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Product</h2>
								<ul>
									<li>
										<a href="javascript:void(0)">Overview</a>
									</li>
									<li>
										<a href="javascript:void(0)">Features</a>
									</li>
									<li>
										<a href="javascript:void(0)">Solutions</a>
									</li>
									<li>
										<a href="javascript:void(0)">Tutorials</a>
									</li>
									<li>
										<a href="javascript:void(0)">Pricing</a>
									</li>
									<li>
										<a href="javascript:void(0)">Releases</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-2 col-md-6 aos" data-aos="fade-up">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Resources</h2>
								<ul>
									<li>
										<router-link to="blog-details">Blog</router-link>
									</li>
									<li>
										<a href="javascript:void(0)">Newsletter</a>
									</li>
									<li>
										<a href="javascript:void(0)">Events</a>
									</li>
									<li>
										<a href="javascript:void(0)">Help Centre</a>
									</li>
									<li>
										<a href="javascript:void(0)">Tutorials</a>
									</li>
									<li>
										<a href="javascript:void(0)">Support</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-2 col-md-6 aos" data-aos="fade-up">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Social</h2>
								<ul>
									<li>
										<a href="javascript:void(0)">Twitter</a>
									</li>
									<li>
										<a href="javascript:void(0)">LinkedIn </a>
									</li>
									<li>
										<a href="javascript:void(0)">Facebook</a>
									</li>
									<li>
										<a href="javascript:void(0)">GitHub</a>
									</li>
									<li>
										<a href="javascript:void(0)">AngelList</a>
									</li>
									<li>
										<a href="javascript:void(0)">Dribble</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-lg-4 col-md-6 aos" data-aos="fade-up">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu">
								<h2 class="footer-title">Subscribe</h2>
								<p>Subscribe to stay tuned for new web design and latest updates. Let's do it!</p>
								<div class="update-form">
									<form action="#">
										<input type="email" class="form-control" placeholder="Enter you email">
										<button type="submit" class="btn btn-primary">Subscribe</button>
									</form>
								</div>
							</div>
							<!-- /Footer Widget -->
						</div>
					</div>
					<div class="footer-bottom">
						<div class="container">
							<!-- Copyright -->
							<div class="copyright">
								<div class="row">
									<div class="col-md-6 aos" data-aos="fade-up">
										<div class="copyright-text">
											<p class="mb-0"> © 2023 Listee. All Rights Reserved.</p>
										</div>
									</div>
									<div class="col-md-6 aos" data-aos="fade-up">
										<!-- Copyright Menu -->
										<div class="copyright-menu">
											<ul class="policy-menu">
												<li>
													<router-link to="about">About Us </router-link>
												</li>
												<li>
													<a href="javascript:void(0);">Careers </a>
												</li>
												<li>
													<a href="javascript:void(0);">Press </a>
												</li>
												<li>
													<a href="javascript:void(0);">News </a>
												</li>
												<li>
													<a href="javascript:void(0);">Media Kit </a>
												</li>
												<li>
													<a href="javascript:void(0);">Contact</a>
												</li>
											</ul>
										</div>
										<!-- /Copyright Menu -->
									</div>
								</div>
							</div>
							<!-- /Copyright -->
						</div>
					</div>
				</div>
			</div>
			<!-- /Footer Top -->
		</footer>
		<!-- /Footer -->
    </template>